import { NewsFeedDetail } from 'modules/news/desktop';
import { getServerSidePropsNewsPage } from 'modules/news/utils';

export default NewsFeedDetail;

export const getServerSideProps = getServerSidePropsNewsPage;
